import React from 'react';
import { FlexBox, Spinner } from '@vp/swan';
import { useTranslations } from '@vp/om-translations';
import PropTypes from 'prop-types';

export const BasicPreloader = props => {
  const [sharedActionMessages] = useTranslations(['sharedActionMessages']);
  const spinnerComponent = (
    <Spinner
      accessibleText={sharedActionMessages.loading}
      role="status"
      aria-live="polite"
      size={props?.size || 'standard'}
      mt={props?.mt}
      mb={props?.mb}
      my={props?.my}
    />
  );
  if (props?.isCentered) {
    return <FlexBox justifyContent="center">{spinnerComponent}</FlexBox>;
  }
  return spinnerComponent;
};

BasicPreloader.propTypes = {
  isCentered: PropTypes.bool,
  size: PropTypes.string,
  mt: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  mb: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  my: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
